import moment from 'jalali-moment';
import axios from './index';

/**
 * @param filters
 *  {
 *    name: 'abc'
 *    email: 'abc'
 *    role: 'passenger'
 *    status: 'active'
 *  }
 */
export const fetchUserList = async (page, limit, filters = {}, sort = undefined) => {
  const params = { page, limit, sort, ...filters };

  const { data } = await axios.get(`/users/admin`, { params });
  return data.data;
};

export const fetchUserInfo = async (id) => {
  const { data } = await axios.get(`/users/admin/${id}`);
  return data.data;
};

export const createUser = async (payload) => {
  const { data } = await axios.post(`/users/admin`, payload);
  return data.messages;
};

export const updateUser = async (id, payload) => {
  const { data } = await axios.put(`/users/admin/${id}`, { ...payload, id });
  return data.messages;
};

export const deleteUser = async (id) => {
  const { data } = await axios.delete(`/users/admin/${id}`);
  return data.messages;
};

/**
 * ------------------- user request -------------------------------------------
 */
export const fetchUserRequestList = async (page, limit, filters = {}, sort = undefined) => {
  const params = { page, limit, sort };

  if (filters.status) params.status = filters.status; // pending | accepted | rejected
  if (filters.type) params.type = filters.type; // role | level | message

  if (filters.startDate || filters.endDate) {
    const dates = [];
    if (filters.startDate) dates.push(`gte:${moment(filters.startDate).format('YYYY-MM-DD')}`);
    if (filters.endDate) dates.push(`lte:${moment(filters.endDate).format('YYYY-MM-DD')}`);
    params.date = dates.join('[and]');
  }

  const { data } = await axios.get(`/users/requests/admin`, { params });
  return data.data;
};

export const fetchUserRequestInfo = async (id) => {
  const { data } = await axios.get(`/users/requests/admin/${id}`);
  return data.data;
};

export const updateUserRequest = async (id, status, adminMessage) => {
  const { data } = await axios.put(`/users/requests/admin/${id}`, { status, adminMessage });
  return data.messages;
};

/**
 * ------------------- user currency -------------------------------------------
 */
export const fetchUserCurrencies = async (userId) => {
  const { data } = await axios.get(`/users/currencies/admin`, { params: { user_id: userId } });
  return data.data;
};

export const updateUserCurrency = async (payload) => {
  const { data } = await axios.put(`/users/currencies/admin`, payload);
  return data.messages;
};
